import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconSheets = props => (
  <SvgIcon {...props} viewBox="0 0 19 22">
    <path d="m14 0h-12c-1.1 0-2 0.9-2 2v14h2v-14h12v-2zm3 4h-11c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h11c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zm0 16h-11v-14h11v14z" />
  </SvgIcon>
);

export default IconSheets;



// WEBPACK FOOTER //
// ./src/components/icons/IconSheets.js